// src/app/services/custom-toast.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CustomToastService {
  show(title: string, message: string, targetUrl?: string) {
    const container = document.createElement('div');
    container.classList.add('custom-toast-box');

    container.innerHTML = `
      <div class="custom-toast-content">
        <strong>${title}</strong>
        <p>${message}</p>
        ${targetUrl ? '<button class="toast-btn">Ver más</button>' : ''}
        <ion-icon name="close-outline" class="close-icon"></ion-icon>
      </div>
    `;

    document.body.appendChild(container);

    const closeBtn = container.querySelector('.close-icon');
    const actionBtn = container.querySelector('.toast-btn');

    closeBtn?.addEventListener('click', () => container.remove());
    actionBtn?.addEventListener('click', () => {
      if (targetUrl) window.location.href = targetUrl;
      container.remove();
    });

    setTimeout(() => container.remove(), 5000); // auto-cierre
  }
}
